export class MediaMediaHashTagViewModel {
    public mediaMediaHashTagId: string;
    public mediaHashtagId: string;
    public mediaHashtagName: string;
    public displaySequence: Number;
}
